var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fc-selected-day",class:_vm.selectedClass,style:(`${_vm.eventStyle}`)},[_vm._t("default"),_c('i',{staticClass:"el-icon-remove",on:{"click":function($event){return _vm.$emit('cellRemoved')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }